module.exports = __webpack_public_path__ + "img/dropDownIcon.2cbb3f24.svg";